import { useBottomPanel } from '@ubnt/link-core-ui/components/BottomPanel/context/BottomPanelContext';
import { useCallback } from 'react';

import { useDispatch, useSelector } from 'app/store';
import {
  devicesDeviceAfcSelector,
  devicesDeviceChannelsOptionsSelector,
  devicesDeviceIsSixBandActiveSelector,
  devicesDeviceVariantParamsUpdate,
  devicesDeviceVariantSelector,
  devicesMeshDeviceVariantSelector,
} from 'modules/devices/slice';
import {
  linksDeviceChannelSelector,
  linksIsChannelAutoSelector,
  linksMeshUplinkApIdSelector,
  linksMeshUplinkIdSelector,
} from 'modules/links/slice';
import { trackEvent } from 'utils/googleAnalytics';

import ChannelDropdown, {
  AUTO_CHANNEL,
  AUTO_CHANNEL_LABEL,
  AUTO_CHANNEL_TYPE,
  ChannelDropdownProps,
} from '../components/elements/ChannelDropdown';

const ChannelDropdownContainer = (props: Partial<ChannelDropdownProps>) => {
  const { leftId: id, linkId } = useBottomPanel();

  const uplinkApId = useSelector((state) => (linkId ? linksMeshUplinkApIdSelector(state, linkId) : false));
  const uplinkId = useSelector((state) => (linkId ? linksMeshUplinkIdSelector(state, linkId) : undefined));
  const variant = useSelector((state) => (id ? devicesDeviceVariantSelector(state, id) : undefined));
  const uplinkVariant = useSelector((state) => (uplinkId ? devicesMeshDeviceVariantSelector(state) : undefined));
  const controlsUplinkAp = uplinkVariant === variant && uplinkApId;
  const changeId = controlsUplinkAp ? uplinkApId : id;
  const changeLinkId = controlsUplinkAp ? uplinkId : linkId;
  const isAfcEnabled = useSelector((state) =>
    changeId ?
      devicesDeviceAfcSelector(state, changeId) && devicesDeviceIsSixBandActiveSelector(state, changeId)
    : false
  );
  const channel = useSelector((state) =>
    isAfcEnabled ? AUTO_CHANNEL_LABEL : (
      changeLinkId &&
      changeId &&
      linksDeviceChannelSelector(state, changeLinkId, devicesDeviceVariantSelector(state, changeId))
    )
  );
  const channels = useSelector(
    (state) =>
      changeId && devicesDeviceChannelsOptionsSelector(state, changeId, devicesDeviceVariantSelector(state, changeId))
  );
  const isAuto = useSelector(
    (state) =>
      !!(
        changeLinkId &&
        changeId &&
        linksIsChannelAutoSelector(state, changeLinkId, devicesDeviceVariantSelector(state, changeId))
      )
  );
  const dispatch = useDispatch();

  const onChange = useCallback(
    (_: { label: string; value: React.Key }, value: React.Key) => {
      if (changeId && variant != null && value != channel) {
        let newChannel: number | AUTO_CHANNEL_TYPE;
        if (value === AUTO_CHANNEL) {
          newChannel = value;
        } else {
          newChannel = Number(value);
        }

        dispatch(devicesDeviceVariantParamsUpdate({ id: changeId, variant, changes: { channel: newChannel } }));
        trackEvent('bottomPanelChannelChange', { variant, channel: newChannel });
      }
    },
    [changeId, variant, channel, dispatch]
  );

  if (!id || !channel || !channels) {
    return null;
  }

  return (
    <ChannelDropdown
      disabled={!!controlsUplinkAp}
      channel={channel.toString()}
      channels={channels}
      label="Channel"
      isAuto={isAuto}
      onChange={onChange}
      {...props}
    />
  );
};

export default ChannelDropdownContainer;
